import React, { useState } from "react";

import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useAttendanceReport } from "./Attendance _report/useAttendance_report";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { showToast } from "../../utils/toastUtils";
import { getAttendance_Report } from "./Attendance _report/Attendance_report_Repo";
import { COLORS } from "../../constants/colors";

const AttendanceReport = () => {
  const { startPolling } = useExcelPolling();

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const [filterData, setFilterData] = useState({
    start_date: "",
    end_date: "",
    start: 1,
    length: 10,
    action: "view",
  });

  const {
    data: dataForAttendance,
    isLoading,
    isSuccess,
  } = useAttendanceReport({
    enable: true,
    param: {
      ...(filterData.start_date === ""
        ? {}
        : { start_date: filterData.start_date }),
      ...(filterData.end_date === "" ? {} : { end_date: filterData.end_date }),
      start: filterData.start,
      length: filterData.length,
      action: filterData.action,
    },
  });

  const downloadExcelGet = async () => {
    const param = {
      ...(filterData.start_date === ""
        ? {}
        : { start_date: filterData.start_date }),
      ...(filterData.end_date === "" ? {} : { end_date: filterData.end_date }),
      start: filterData.start,
      length: filterData.length,
      action:'download',
    };

    try {
      setLoadingExcel(true);
      const response = await getAttendance_Report(param);
      // console.log('response',response);
      const { success, fileDownloadId, intervalTime } =
        response.rowData.data || {};
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: string) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFaled: (message: string) =>
            showToast.error(
              message || "onFalied error in Attendance  report excel"
            ),
          onExpired: (message: string) =>
            showToast.error(
              message || "onExpired error in  Attendance report excel"
            ),
          onDeleted: (message: string) =>
            showToast.error(
              message || "onDeleted error in Attendance report excel "
            ),
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in Attendance report");
    }
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  const handleEndDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterData((prev: any) => ({
      ...prev,
      end_date: e.target.value,
    }));
  };
  const handleStartDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterData((prev: any) => ({
      ...prev,
      start_date: e.target.value,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Attendance Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
         search={false}
        Title="Attendance Report"
        dynamicHeightOnRowsPerPage={true}
        data={
          (!isLoading && isSuccess && dataForAttendance?.formatedData) || []
        }
        showSpinner={isLoading}
        columns={AttendanceReportColoumn}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <label style={{ color: "black", marginTop: "7px" }}>
              Start Date
            </label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleStartDate(e)
              }
            />
            <label style={{ color: "black", marginTop: "7px" }}>End Date</label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleEndDate(e)
              }
            />
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={dataForAttendance?.rowData.data.recordsTotal || 0}
      />
    </div>
  );
};
export default AttendanceReport;

const AttendanceReportColoumn = [
  {
    name: "Employee Code",
    selector: (row: { EmployeeCode?: string }) =>
      row.EmployeeCode ? row.EmployeeCode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Employee Name",
    selector: (row: { EmployeeName?: string }) =>
      row.EmployeeName ? row.EmployeeName : "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Attendance Date",
    selector: (row: { AttendanceDate?: string }) =>
      row.AttendanceDate ? row.AttendanceDate : "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Attendance Status",
    selector: (row: { AttendanceStatus?: string }) =>
      row.AttendanceStatus ? row.AttendanceStatus : "-",
    sortable: true,
    width: "220px",
  },
  {
    name: "Created Date",
    selector: (row: { CreatedDate?: string }) =>
      row.CreatedDate ? row.CreatedDate : "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Start Time",
    selector: (row: { StartTime?: string }) =>
      row.StartTime ? row.StartTime : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "End Time",
    selector: (row: { EndTime?: string }) => (row.EndTime ? row.EndTime : "-"),
    sortable: true,
    width: "160px",
  },
  {
    name: "Start Lating",
    selector: (row: { StartLating?: string }) =>
      row.StartLating ? row.StartLating : "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "End Lating",
    selector: (row: { EndLating?: string }) =>
      row.EndLating ? row.EndLating : "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Selfie",
    selector: (row: { Selfie?: string }) => (row.Selfie ? row.Selfie : "-"),
    sortable: false,
    width: "180px",
  },
];
